export default __webpack_public_path__ + "static/media/select_year.24c6f637.png";